import React from 'react';
import { graphql, usePreloadedQuery, type EntryPointProps } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { DashboardsContent } from '../../../../common/ui/content/DashboardsContent.tsx';
import type { DashboardsContentViewQuery } from './__generated__/DashboardsContentViewQuery.graphql';

type Queries = { queryRef: DashboardsContentViewQuery };

export default function DashboardsContentViewQuery({
	queries: { queryRef },
}: EntryPointProps<Queries, {}, Partial<EntryPointRouteParams>, {}>): React.JSX.Element {
	const data = usePreloadedQuery<DashboardsContentViewQuery>(
		graphql`
			query DashboardsContentViewQuery($cloudId: ID!) @preloadable {
				...DashboardsContent
			}
		`,
		queryRef,
	);

	return <DashboardsContent queryRef={data} />;
}
